import React from "react";
import Modal from "./Modal";
import styles from "./ThankYouModal.module.scss";

const ShieldCheckIcon = () => (
  <svg width="48" height="48" viewBox="0 0 24 24" fill="none">
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" stroke="#0f1d57" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M9 12l2 2 4-4" stroke="#d08b1d" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const EmailIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#d08b1d" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
    <polyline points="22,6 12,13 2,6" />
  </svg>
);

const WhatsAppIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="#d08b1d">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
  </svg>
);

const HeartIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#d08b1d" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path>
  </svg>
);

export default function ThankYouModal({ isOpen, onClose }) {
  if (!isOpen) return null;

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className={styles.modalBackdrop} onClick={handleBackdropClick}>
      <div className={styles.modalContent}>
        <button className={styles.closeButton} onClick={onClose} aria-label="Close">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>

        <div className={styles.container}>
          <div className={styles.iconWrapper}>
            <div className={styles.iconCircle}>
              <ShieldCheckIcon />
            </div>
            <div className={styles.sparkle1}>✦</div>
            <div className={styles.sparkle2}>✦</div>
            <div className={styles.sparkle3}>✦</div>
            <div className={styles.sparkle4}>✦</div>
          </div>

          <h2 className={styles.title}>Thank You</h2>
          
          <div className={styles.divider}>
            <div className={styles.line}></div>
            <div className={styles.dot}></div>
            <div className={styles.line}></div>
          </div>

          <h3 className={styles.subtitle}>
            Your details have been received successfully.
          </h3>

          <p className={styles.message}>
            Thank you for taking the time to connect with Munafa Engine.<br />
            Our team will review the details you have shared and take<br />
            the conversation forward through the most appropriate channel.
          </p>

          <div className={styles.contactBox}>
            <div className={styles.contactHeader}>
              <div className={styles.line}></div>
              <span>Prefer to connect directly?</span>
              <div className={styles.line}></div>
            </div>

            <div className={styles.contactMethods}>
              <div className={styles.contactMethod}>
                <div className={styles.methodIcon}>
                  <EmailIcon />
                </div>
                <div className={styles.methodDetails}>
                  <span className={styles.methodTitle}>Email</span>
                  <span className={styles.methodValue}>connect@munafaengine.com</span>
                </div>
              </div>

              <div className={styles.contactMethod}>
                <div className={styles.methodIcon}>
                  <WhatsAppIcon />
                </div>
                <div className={styles.methodDetails}>
                  <span className={styles.methodTitle}>WhatsApp</span>
                  <a href="https://wa.me/15559303709?text=Hi%20Munafa%20Engine%2C%20I%20want%20to%20know%20more%20about%20weekly%20salon%20clarity." target="_blank" rel="noopener noreferrer" className={styles.whatsappLink}>
                    Chat on WhatsApp
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className={styles.footer}>
            <HeartIcon />
            <span>We appreciate your interest in Munafa Engine.</span>
          </div>
        </div>
      </div>
    </div>
  );
}
